import { useEffect } from 'react';
import {
  LandingHeader,
  LandingHero,
  LandingIntro,
  LandingIndustries,
  LandingFeatures,
  LandingTechFeatures,
  LandingBenefits,
  LandingStorage,
  LandingEco,
  LandingRoadmap,
  LandingCta,
  LandingFooter,
} from "@/components/landing";
import { useSystemSettings } from '@/hooks/useSystemSettings';
import MaintenancePage from './Maintenance';

const Landing = () => {
  const { settings, loading } = useSystemSettings();

  // Intersection Observer para animações de reveal
  useEffect(() => {
    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('active');
        }
      });
    }, { threshold: 0.1 });

    const observeElements = () => {
      document.querySelectorAll('.reveal').forEach(el => observer.observe(el));
    };

    observeElements();
    const timer = setTimeout(observeElements, 500);

    return () => {
      clearTimeout(timer);
      observer.disconnect();
    };
  }, []);

  if (!loading && settings?.landing_maintenance_mode) {
    return <MaintenancePage forceActive={true} />;
  }

  return (
    <div className="min-h-screen flex flex-col selection:bg-primary selection:text-white bg-white">
      {/* Custom CSS for animations */}
      <style>{`
        @keyframes fade-in {
          from {
            opacity: 0;
            transform: translateY(30px);
          }
          to {
            opacity: 1;
            transform: translateY(0);
          }
        }
        
        .animate-fade-in {
          animation: fade-in 0.8s ease-out forwards;
        }
        
        .reveal {
          opacity: 0;
          transform: translateY(30px);
          transition: all 0.8s ease-out;
        }
        
        .reveal.active {
          opacity: 1;
          transform: translateY(0);
        }
        
        /* Smooth scroll behavior */
        html {
          scroll-behavior: smooth;
        }
        
        /* Custom scrollbar */
        ::-webkit-scrollbar {
          width: 8px;
        }
        
        ::-webkit-scrollbar-track {
          background: #f1f1f1;
        }
        
        ::-webkit-scrollbar-thumb {
          background: #22c55e;
          border-radius: 4px;
        }
        
        ::-webkit-scrollbar-thumb:hover {
          background: #16a34a;
        }
      `}</style>

      <LandingHeader />
      <main className="flex-grow">
        <LandingHero />
        <LandingIntro />
        <LandingIndustries />
        <LandingFeatures />
        <LandingTechFeatures />
        <LandingBenefits />
        <LandingStorage />
        <LandingEco />
        <LandingRoadmap />
        <LandingCta />
      </main>
      <LandingFooter />
    </div>
  );
};

export default Landing;
